import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import '../../local_node_modules/react-select/dist/react-select.css';
import {hasUserRight, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import SweetAlert from 'react-bootstrap-sweetalert';
import StockModal from "./StockModal";
import NavBarKS from "../../components/NavBarKS";
import Alert from "react-s-alert";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import StickButton from "../../components/StickButton";
import ReadFromExcel from "../voucher/component/ReadFromExcel";
import {showBaro} from "../../helper/permission"
import {UserRightsEnum} from "../../helper/enums";
import {VirtualHost} from "../../constants";
import XLSX from "xlsx";
import moment from "moment/moment";

class StockList extends Component{
	constructor(props){
		super(props);
		this.state ={
		    content:[],
            unitCodes:[],
            exemptions:[],
			currencyCodes:[],
            total:0,
			loading:false,
            page:0,
            size:10,
			stock:null,
            stockModal:false,
			selection: [],
			selectedAll: false,
		};
		this.handleEdit 	= this.handleEdit.bind(this);
		this.handleCreate 	= this.handleCreate.bind(this);
		this.handleDelete 	= this.handleDelete.bind(this);
		this.fetchData 		= this.fetchData.bind(this);
		this.confirmDelete 	= this.confirmDelete.bind(this);
		this.cancelDelete 	= this.cancelDelete.bind(this);
		this.setStocks 		= this.setStocks.bind(this);
        this.handleSearch 	= this.handleSearch.bind(this);
        this.getUnitLongCode= this.getUnitLongCode.bind(this);
        this.isSelected= this.isSelected.bind(this);
        this.toggleCheckboxChange= this.toggleCheckboxChange.bind(this);
        this.deleteSelected= this.deleteSelected.bind(this);
		this.exportToExcel = this.exportToExcel.bind(this);
		this.exportToExcelAllStock = this.exportToExcelAllStock.bind(this);

	}

	componentWillMount() {
		let self=this;
		let params = {url:`/stock/getCodes`,
			method:"post",
		};
		request(params)
		.then(response =>{
			self.setState({
                unitCodes:response.data.unitCodes,
                currencyCodes:response.data.currencyCodes,
                exemptions:response.data.exemptions,
				withholdingTypes: response.data.withholdingTypes,
            });
		})
		.catch(function (error) {
			showAxiosError(error);
		});
	}

	fetchData(accessor,direction,page,size){
		let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/stock/getStocks?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "post"
		};
        self.setState({loading: true, manual: self.manual === true ? false: self.manual});
        self.props.reload(true);
		request(params)
		.then(function (response) {
            self.setState({
                page: page,
                size: size,
                total: response.data.totalElements,
                content: response.data.content,
                loading: false,
                searching: false,
				selectedAll: false
            });
            self.props.reload(false);
		}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

    handleSearch(searchQuery) {
        this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

	handleDelete(item){
		this.setState({showSwal:true,item:item, selection: []});
	}

	cancelDelete(){
		this.setState({showSwal:false,item:null});
	}

	confirmDelete(){
		let self = this;
		let item = self.state.item;
		let params = {
			url:`/stock/delete/${item.recordId}`,
			method :'post'
		};
		self.setState({deleteBtnDisabled:true});
		request(params)
		.then(function (response) {
            self.setState({showSwal: false, deleteBtnDisabled: false, manual: true});
            Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000,
				html:false
            });
		}).catch(function (error) {
			self.setState({loading: false,showSwal:false,deleteBtnDisabled:false, selection: null});
			showAxiosError(error);
		});
	}

	handleCreate(){
		this.setState({stock:null,stockModal:true,isCreate:true});
	}

	handleEdit(item){
		this.setState({stock:item,stockModal:true,isCreate:false});
	}

	setStocks(stock,isSetParent){
		if(!isSetParent){
			this.setState({stockModal:false});
		}else{
			let content = this.state.content;
			let total = this.state.total;
			if(this.state.isCreate){
				if(content.length < this.state.size)
					content.push(stock);
				total = total +1;
			}else{
				let index= (content.map(function (data) {
					return data.recordId;
				})).indexOf(stock.recordId);
				content[index] = stock;
			}
			this.setState({total:total,content:content,stockModal:false, manual: true});
		}
	}

    getUnitLongCode(baseUnit){
        const unitCode = this.state.unitCodes.find((item) => (item.shortCode === baseUnit));
	    return (unitCode ? unitCode.longCode : baseUnit);
    }

	isSelected(id) {
		return (this.state.selection.indexOf(id) !== -1);
	}

	toggleCheckboxChange(e, row, id) {
		let self = this;
		let checked = e.target.checked;
		let items = self.state.content;
		let selection = self.state.selection;
		if (row === "all") {
			let selection = [];
			if (checked) {
				items.forEach(item => {
					selection.push(item[id]);
				});
			}
			self.setState({selection: selection, selectedAll: checked});
		} else {
			let index = selection.indexOf(row[id]);
			if (index >= 0) {
				selection = [
					...selection.slice(0, index),
					...selection.slice(index + 1)
				];
			} else {
				selection.push(row[id]);
			}
			self.setState({
				selection: selection,
				selectedAll: ((selection.length > 0) ? (selection.length === self.state.content.length) : false)
			});
		}
	}

	deleteSelected() {
		let self = this;
		let selection = self.state.selection;
		let params = {
			url:`/stock/deleteMultiple`,
			method :'post',
			data: selection
		};
		self.setState({deleteBtnDisabled:true});
		request(params)
			.then(function (response) {
				self.setState({loading: false, deleteBtnDisabled: false, manual: true, selection: []});
				Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000,
					html:false
				});
			}).catch(function (error) {
			self.setState({loading: false,deleteBtnDisabled:false, selection: []});
			showAxiosError(error);
		});
	}

	prepareExcelData(records) {
		const data = [{
			stockCode: "Ürün-Hizmet_Kodu",
			stockName: "Ürün-Hizmet_Adı",
			kdvBuy: "Kdv_Alış(%)",
			kdvSell: "Kdv_Satış(%)",
			priceBuy: "Birim_Fiyat_Alış",
			priceSell: "Birim_Fiyat_Satış",
			currency: "Para_Birimi",
			unit: "Birim",
			alias: "Ürün-Hizmet_Etiket",
			explanation: "Ürün-Hizmet_Açıklaması",
			kdvPurchaseExemption: "Kdv_Alış_İstisna_Sebebi",
			kdvSellExemption: "Kdv_Satış_İstisna_Sebebi",
			gtip: "Gtip_Numarası"
		}];

		records.forEach(line => {
			const row = {
				stockCode: line.code || "",
				stockName: line.name || "",
				kdvBuy: line.kdvPurchase || "",
				kdvSell: line.kdvSell || "",
				priceBuy: line.defPricePurchase || "",
				priceSell: line.defPriceSell || "",
				currency: line.defaultCurrencyCode || "",
				unit: line.baseUnit || "",
				alias: line.alias || "",
				explanation: line.explanation || "",
				kdvPurchaseExemption: line.kdvPurchaseExemption || "",
				kdvSellExemption: line.kdvSellExemption || "",
				gtip: line.gtip || ""
			};
			data.push(row);
		});

		return data;
	}

	async exportToExcel(e) {
		const {content, selection} = this.state;

		if (!content || !content.length || !selection || !selection.length) {
			showAxiosError({message: "İçerik veya seçili öğeler bulunamadı."});
			return;
		}

		const selectedItems = content.filter(item => selection.includes(item.recordId));

		if (!selectedItems.length) {
			showAxiosError({message: "Seçili öğeler bulunamadı."});
			return;
		}

		try {
			await this.generateExcelFile(selectedItems, "Ürün-Hizmet Bilgisi");
		} catch (error) {
			showAxiosError({message: "Excel dosyası oluşturma hatası: " + error.message});
			this.setState({loading: false, searching: false});
		}
	}

	async exportToExcelAllStock(fileName) {
		try {
			const allStocks = await this.fetchAllStock();
			if (allStocks !== null) {
				await this.generateExcelFile(allStocks, "Ürün/Hizmet Listesi");
			} else {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			}
		} catch (error) {
			showAxiosError(error);
		}
	}


	async generateExcelFile(data, fileName) {
		const preparedData = this.prepareExcelData(data);
		const ws = XLSX.utils.json_to_sheet(preparedData, {skipHeader: true});
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "ÜrünHizmet");
		XLSX.writeFile(wb, fileName + "_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
	}

	async fetchAllStock() {
		let self = this;
		let params = {
			url: `/stock/listStocks`,
			method: "post",
		};

		self.setState({processing: true});

		try {
			const response = await request(params);
			const allStock = response.data;
			self.setState({processing: false});
			return allStock;
		} catch (error) {
			self.setState({processing: false, searching: false});
			showAxiosError(error);
			return null;
		}
	}


	render(){
		const source = VirtualHost.conf.resourcePrefix;

		let columns = [
			{
				Header: (<input type="checkbox" checked={this.state.selectedAll}
								onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
				accessor: "recordId",
				selectType: "checkbox",
				sortable: false,
				Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
											  onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
			},
			{
				Header: "Ürün/Hizmet Kodu",
				title: "Ürün/Hizmet Kodu",
				accessor: "code"
			},
			{
				Header: "Ürün/Hizmet Adı",
				title: "Ürün/Hizmet Adı",
				accessor: "name"
			},
			{
				Header: "GTİP Numarası",
				title: "GTİP Numarası",
				accessor: "gtip"
			},
			{
                Header: "KDV Alış (%)",
                title: "KDV Alış (%)",
				accessor: "kdvPurchase",
				Cell: row => (<div>{row.kdvPurchase} </div>)
			},
			{
                Header: "KDV Satış (%)",
                title: "KDV Satış (%)",
				accessor: "kdvSell",
				Cell: row => (<div>{row.kdvSell} </div>)
			},
			{
                Header: "Birim Fiyat Alış",
                title: "Birim Fiyat Alış",
                accessor: "defPricePurchase",
				Cell: row => (<div>{row.defPricePurchase} {row.defaultCurrencyCode}</div>)
			},
			{
                Header: "Birim Fiyat Satış",
                title: "Birim Fiyat Satış",
                accessor: "defPriceSell",
				Cell: row => (<div>{row.defPriceSell} {row.defaultCurrencyCode}</div>)
			},
			{
                Header: "Birim",
                title: "Birim",
                accessor: "baseUnit",
                sortable:false,
				Cell: row => (<div><TextOverFlowTooltip text={this.getUnitLongCode(row.baseUnit)} maxLength={20}/></div>)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				accessor: "",
				sortable:false,
				Cell: item => (
					<div>
						<button type="button"
								onClick={() => this.handleEdit(item)}
								data-toggle="tooltip" data-placement="bottom" title="Düzenle"
								style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}} rel="tooltip"
								disabled={!hasUserRight(UserRightsEnum.settings.stockCard.update,this.props.currentUser)}
								className="Btn  btn-icon">
							<i className="BtnIcon far fa-edit "/>
						</button>
						<button type="button"
								onClick={() => this.handleDelete(item)}
								data-toggle="tooltip" data-placement="bottom" title="Sil"
								disabled={!hasUserRight(UserRightsEnum.settings.stockCard.delete,this.props.currentUser)}
								style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
								rel="tooltip" className="Btn  btn-icon">
								<i className="BtnIcon far fa-trash-alt"/>
						</button>
					</div>
				)
			}
		];

        let fields = [
            {
                label: "Ürün/Hizmet Kodu",
                accessor: "code",
                type: "text",
                operator: "=",
            },
            {
                label: "Ürün/Hizmet Adı",
                accessor: "name",
                type: "text",
                operator: "=",
            }
        ];

		if (showBaro()) {
			columns = columns.filter(c => ["code", "kdvPurchase", "defPricePurchase", "baseUnit"].indexOf(c.accessor) === -1);
			fields = fields.filter(f => f.accessor !== "code");
		}
		return (
			<div className="row baseBackground stockListContainer">

			<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name='stockList'
					  selection={this.state.selection}>

				<StickButton position="leftSide"
							 onClick={() => this.handleCreate()}
							 label="Yeni Oluştur"
							 title="Yeni Oluştur"
							 disabled={!hasUserRight(UserRightsEnum.settings.stockCard.create,this.props.currentUser)}
							 className="stickButton plus-circle"
							 icon="plus-circle"/>

				<StickButton position="leftSide"
							 title="Excel'den Kaydet"
							 label="Excel'den Kaydet"
							 className="stickButton excel"
							 disabled={!hasUserRight(UserRightsEnum.settings.stockCard.create,this.props.currentUser)}
							 icon="excel"
							 onClick={(e) => this.setState({showExcelModal: true})}/>

				<StickButton position="leftSide"
							 title="Seçilileri Sil"
							 label="Seçilileri Sil"
							 className="stickButton trash"
							 disabled={!(this.state.selection.length > 0) || !hasUserRight(UserRightsEnum.settings.stockCard.delete, this.props.currentUser)}
							 onClick={(e) => this.deleteSelected()}
							 icon='trash'/>

				<StickButton position="leftSide"
							 onClick={this.exportToExcelAllStock}
							 label={this.state.processing ? "Oluşturuluyor..." : "Tümünü Excel'e Aktar"}
							 title="Tümünü Excel'e Aktar"
							 className="stickButton excel"
							 icon="excel"/>

				<StickButton position="leftSide"
							 onClick={this.exportToExcel}
							 label="Excel'e Aktar"
							 title="Excel'e Aktar"
							 className="stickButton excel"
							 icon="excel"
							 disabled={(this.state.selection.length <= 0)}/>

				</NavBarKS>
				<div className="col-sm-12 satirBasi">
					<div className="card-header">
						<h4 className="card-title">Ürün/Hizmet Listesi</h4>
					</div>
					<div className="card-body">
						<DetailedSearch fields={fields}
										loading={this.state.searching}
										onSearch={this.handleSearch}/>
					</div>

					<div className="card-body row">
						<Table columns={columns}
							   loading={this.state.loading}
							   loadingText="Kayıtlar getiriliyor..."
							   content={this.state.content}
							   total={this.state.total}
							   page={this.state.page}
							   manual={this.state.manual}
							   size={this.state.size}
							   options={["5", "10", "20", "50", "100"]}
							   fetchData={this.fetchData}
						/>
					</div>
				</div>
				{this.state.showSwal &&
					<SweetAlert
						showCancel
						closeOnClickOutside={false}
						hideOverlay={false}
						disabled={this.state.deleteBtnDisabled}
						confirmBtnText="Evet"
						confirmBtnCssClass="TekBtn gonder"
						confirmBtnStyle={{float: 'right'}}
						cancelBtnText="Hayır"
						cancelBtnCssClass="TekBtn vazgec"
						cancelBtnStyle={{
							background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
							float: 'left'
						}}
						confirmBtnBsStyle="success"
						cancelBtnBsStyle="default"
						title="Silme Onayı"
						style={{width: 400}}
						onConfirm={this.confirmDelete}
						onCancel={this.cancelDelete}
					>
						Ürün/Hizmet Bilgisinin silinmesini onaylıyor musunuz?
					</SweetAlert>
				}

				{this.state.stockModal &&
					<StockModal listener={this.setStocks}
								modal={this.state.stockModal}
								stock={this.state.stock}
								isCreate={this.state.isCreate}
								currencyCodes={this.state.currencyCodes}
                                exemptions={this.state.exemptions}
								unitCodes={this.state.unitCodes}
								isGtipRequired={false}
								withholdingTypes={this.state.withholdingTypes}
								type="stock"
					/>
				}

				{this.state.showExcelModal &&
				<ReadFromExcel
					type="stockList"
					profileId={this.props.profileId}
					toggleModal={(flag, manual) => this.setState({showExcelModal: flag, manual: manual})}
					modal={this.state.showExcelModal}/>
				}
			</div>
		);
	}
}

export default StockList;